import React, { useContext, useState } from 'react'
import { GlobalContext } from '../context/globalContext'

const AddTransaction = () => {
  const { dispatch } = useContext(GlobalContext)

  const [text, setText] = useState('')
  const [amount, setAmount] = useState(0)

  const submit = (e) => {
    e.preventDefault()

    const newTrans = {
      id: crypto.randomUUID,
      text,
      amount: +amount,
      date: new Date().toISOString(),
    }

    dispatch({ type: 'ADD', payload: newTrans })

    setText('')
    setAmount(0)
  }
  return (
    <div>
      <h3>Add transaction</h3>
      <form onSubmit={submit}>
        <input
          type="text"
          placeholder="Description..."
          value={text}
          onChange={(e) => setText(e.target.value)}
        />
        <input
          type="number"
          placeholder="Sum..."
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />
        <button type="submit">Add</button>
      </form>
    </div>
  )
}

export default AddTransaction
